import hasClass from '../../../general/class/hasClass';

// ----------------------------------------------------------------------------

function hasSelected(element: HTMLSelectElement): boolean {
    for (const elOption of element.options) {
        if (elOption.selected || hasClass(elOption, 'selected')) {
            return true;
        }
    }

    return false;
}

// ----------------------------------------------------------------------------

export default hasSelected;
